import React from "react";
import "./DataFetchingSpinner.css";
import DefaultSpinner from "./DefaultSpinner";

const DataFetchingSpinner: React.FC = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center">
      <DefaultSpinner className="[&_div]:bg-white bg-black/80 z-50" />
    </div>
  );
};

export default DataFetchingSpinner;
